import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './SuccessConfetti.css';
import successConfetti from '../../assets/img/success-confetti.svg';

/**
 * SuccessConfetti component with a custom animation.
 * The animation zooms, scales to larger size, fades in, and spins.
 * Includes an onAnimationEnd callback and configurable scale size.
 */
const SuccessConfetti = ({
  src = successConfetti,
  alt,
  duration = '2s',
  delay = '0s',
  scale = 1.2,
  onAnimationEnd,
  className,
  ...props
}) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    const element = confettiRef.current;
    if (element && onAnimationEnd) {
      const handleAnimationEnd = () => onAnimationEnd();
      element.addEventListener('animationend', handleAnimationEnd);

      return () => {
        element.removeEventListener('animationend', handleAnimationEnd);
      };
    }
  }, [onAnimationEnd]);

  const style = {
    animationDuration: duration,
    animationDelay: delay,
    '--confetti-scale': scale // Custom property to control scale in CSS
  };

  return (
    <img
      ref={confettiRef}
      src={src}
      alt={alt}
      className={`success-confetti ${className}`}
      style={style}
      {...props}
    />
  );
};

SuccessConfetti.propTypes = {
  alt: PropTypes.string.isRequired,
  duration: PropTypes.string,
  delay: PropTypes.string,
  scale: PropTypes.number,
  onAnimationEnd: PropTypes.func,
  className: PropTypes.string
};

SuccessConfetti.defaultProps = {
  duration: '2s',
  delay: '0s',
  scale: 1.2,
  onAnimationEnd: null,
  className: ''
};

export default SuccessConfetti;
